import { Injectable } from '@angular/core';

import { Subject, Observable } from 'rxjs';

import { DynamicFormDesignerComponent } from '../dynamic-form-designer.component';
import { AbstractToolService } from './abstract-tool.service';
import { SelectToolService } from './select-tool.service';
import { DrawToolService } from './draw-tool.service';
import { CutToolService } from './cut-tool.service';
import { CopyToolService } from './copy-tool.service';
import { MoveUpToolService } from './move-up-tool.service';
import { MoveDownToolService } from './move-down-tool.service';
import { DragDrawToolService } from './drag-draw-tool.service';
import { SharedService } from '../services/shared.service';

import { ControlSpecification } from '../types/specification.types';

@Injectable({
  providedIn: 'root'
})
export class ToolAdapterService {
  get designer(): DynamicFormDesignerComponent {
    return this._designer;
  }
  set designer(value: DynamicFormDesignerComponent) {
    this._designer = value;
    this.designerChanged(value);
  }

  get currentTool(): AbstractToolService {
    return this._currentTool;
  }
  set currentTool(value: AbstractToolService) {
    const current = this._currentTool;
    this._currentTool = value;
    this.currentToolChanged(current, value);
  }

  get cursor$(): Observable<string> {
    return this._cursor.asObservable();
  }

  private _cursor = new Subject<string>();

  private _designer: DynamicFormDesignerComponent;
  private _currentTool: AbstractToolService;

  constructor(
    private selectTool: SelectToolService,
    private drawTool: DrawToolService,
    private dragDrawTool: DragDrawToolService,
    private cutTool: CutToolService,
    private copyTool: CopyToolService,
    private moveUpTool: MoveUpToolService,
    private moveDownTool: MoveDownToolService,
    private sharedService: SharedService
  ) {
    this.initializeTools();
  }

  changeCursor(cursor: string) {
    this._cursor.next(cursor);
  }

  do(host: any, args: any) {
    this.currentTool.do(host, args);
  }

  reset() {
    this.currentTool = this.selectTool;
    this.changeCursor('');
  }

  /**
   * @ åæ¢å°éæ©å·¥å·
   *
   * @memberof ToolAdapterService
   */
  startSelect() {
    this.currentTool = this.selectTool;
    this.sharedService.sendChangeToSelectTool();
    this.changeCursor('');
  }

  /**
   * @description å¼å§æ¸²ææ§ä»¶
   *
   * @param specification æ§ä»¶è§æ ¼
   * @memberof ToolAdapterService
   */
  startDraw(specification: ControlSpecification) {
    this.currentTool = this.drawTool;
    this.drawTool.start(specification);
    this.changeCursor('copy');
  }

  /**
   * @description ææ½æ¸²ææ§ä»¶
   *
   * @param specification æ§ä»¶è§æ ¼
   * @memberof ToolAdapterService
   */
  startDragDraw(specification: ControlSpecification) {
    this.currentTool = this.dragDrawTool;
    this.dragDrawTool.start(specification);
  }

  /**
   * @description å¼å§åªå
   *
   * @param source æºæ§ä»¶
   * @memberof ToolAdapterService
   */
  startCut(source: any) {
    this.currentTool = this.cutTool;
    this.cutTool.start(source);
    this.changeCursor('copy');
  }

  /**
   * @description å¼å§æ·è´
   *
   * @param source æºæ§ä»¶
   * @memberof ToolAdapterService
   */
  startCopy(source: any) {
    this.currentTool = this.copyTool;
    this.copyTool.start(source);
    this.changeCursor('copy');
  }

  /**
   * @description ä¸ç§»
   *
   * @param host æºæ§ä»¶
   * @memberof ToolAdapterService
   */
  moveUp(host: any) {
    this.currentTool = this.moveUpTool;
    this.moveUpTool.do(host, {});
  }

  /**
   * @description ä¸ç§»
   *
   * @param host æºæ§ä»¶
   * @memberof ToolAdapterService
   */
  moveDown(host: any) {
    this.currentTool = this.moveDownTool;
    this.moveDownTool.do(host, {});
  }
  // private windowMouseClick(ev: MouseEvent) {
  //   if (ev.button === 2) {
  //     this.Reset();
  //   }
  // }

  private initializeTools() {
    this.selectTool.completed.subscribe((event: any) => {});
    this.drawTool.completed.subscribe((event: any) => {
      this.reset();
    });
    this.dragDrawTool.completed.subscribe((event: any) => {
      this.reset();
    });
    this.cutTool.completed.subscribe((event: any) => {
      this.reset();
    });
    this.copyTool.completed.subscribe((event: any) => {
      this.reset();
    });
    this.moveUpTool.completed.subscribe((event: any) => {
      this.reset();
    });
    this.moveDownTool.completed.subscribe((event: any) => {
      this.reset();
    });
  }

  private designerChanged(designer: DynamicFormDesignerComponent) {
    this.reset();
  }

  private currentToolChanged(current: AbstractToolService, newTool: AbstractToolService) {
    if (current) {
      current.designer = undefined;
    }

    newTool.designer = this.designer;
  }
}
